import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
export default {
    async create(model) {
        return await axios.post(`targets`, model)
    },
    async fetchById(id) {
        return await axios.get(`targets/${id}`)
    },
    async fetch(query, page,filters) {
      
        return await axios.get(`targets?q=${query}&page=${page}&` + buildQuery(filters));
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`targets/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`targets/${id}`)
    },
}
